import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ExtensionType, extensions } from '@pixi/extensions';
var StartupSystem = /*#__PURE__*/function () {
  function StartupSystem(renderer) {
    _classCallCheck(this, StartupSystem);
    this.renderer = renderer;
  }
  _createClass(StartupSystem, [{
    key: "run",
    value: function run(options) {
      var renderer = this.renderer;
      renderer.emitWithCustomOptions(renderer.runners.init, options);
      if (options.hello) {
        console.log("PixiJS ".concat("7.0.5", " - ", renderer.rendererLogId, " - https://pixijs.com"));
      }
      renderer.resize(this.renderer.screen.width, this.renderer.screen.height);
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
  return StartupSystem;
}();
StartupSystem.extension = {
  type: [ExtensionType.RendererSystem, ExtensionType.CanvasRendererSystem],
  name: "startup"
};
extensions.add(StartupSystem);
export { StartupSystem };